export default () =>
  import(/* webpackChunkName: 'coffee/app/download/coffee-mini' */ './Mini');
